/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, VFlow } from 'bold-ui'
import { isBefore, parseISO, subYears } from 'date-fns'
import { MetaPath } from 'util/metaPath'

import PrenatalPartoNascimento, {
  PrenatalPartoNascimentoModel,
} from './prenatal-parto-nascimento/PrenatalPartoNascimento'
import PuericulturaAccordion from './PuericulturaAccordion'

export interface PuericulturaModel {
  prenatal?: PrenatalPartoNascimentoModel
}

export interface PuericulturaViewProps {
  name: MetaPath<PuericulturaModel>
  cidadaoDataNascimento: LocalDate
}

const limitYear = 21
const limitDate = subYears(new Date(), limitYear)

export default function PuericulturaView(props: PuericulturaViewProps) {
  const { name, cidadaoDataNascimento } = props

  if (isBefore(parseISO(cidadaoDataNascimento), limitDate)) return null

  return (
    <Cell size={12}>
      <PuericulturaAccordion>
        <VFlow
          style={css`
            padding: 1rem;
          `}
        >
          <PrenatalPartoNascimento name={name.prenatal} cidadaoDataNascimento={cidadaoDataNascimento} />
        </VFlow>
      </PuericulturaAccordion>
    </Cell>
  )
}
